import http from 'hub-http/clients/apiClient';
import { stringify } from 'hub-http/helpers/params';
export const fetchSequence = id => {
  const url = `sequences/v1/sequence/${id}`;
  return http.get(url);
};
export const updateEnrollment = (enrollment, options) => {
  const queryString = options !== null && options !== void 0 && options.queryParams ? `?${stringify(options.queryParams)}` : '';
  return http.put(`sequences/v1/enrollment${queryString}`, {
    data: enrollment
  });
};
export function enroll(enrollment, vid) {
  const url = `sequences/v1/enrollment/vid/${vid}`;
  const data = {
    sequence: enrollment,
    steps: []
  };
  return http.post(url, {
    data
  });
}
export const unenroll = enrollmentId => {
  const url = `sequences/v1/enrollment/${enrollmentId}/unenroll`;
  return http.post(url);
};
export function unenrollBatch(enrollmentIds) {
  return http.post(`sequences/v1/enrollment/unenroll/batch`, {
    data: {
      ids: enrollmentIds
    }
  });
}
export function fetchPastEnrollment(enrollmentId) {
  return http.get(`sequences/v1/enrollment/${enrollmentId}`);
}
export function moveSequences(sequenceIds, folderId) {
  return http.put('sequences/v1/sequence/move-to-folder/batch', {
    data: {
      sequenceIds,
      destinationFolderId: folderId
    }
  });
}